import { z } from 'zod';
import { knuthShuffle, decodeHtmlEntities } from '@utils/common';
import { baseTaskSchema } from '../schema.base.js';
import { twentyThreeAudioSchema } from '../schema.twenty-three-audio.js';
import { groupTileInput } from './input.tile.js';

const audioDropzoneSchema = z.object({
  type: z.literal("InlineAudio").transform(() => "Audio"),
  src: z.string().nullish().default(null),
  twentyThreeAudio: twentyThreeAudioSchema
}).transform(({
  twentyThreeAudio,
  ...rest
}) => ({
  ...rest,
  src: twentyThreeAudio?.src || rest.src || ""
}));
const imageGroupSchema = z.object({
  type: z.literal("Image"),
  src: z.string(),
  altText: z.string().nullish().default(null),
  audioSrc: z.string().nullable().default(null),
  twentyThreeAudio: twentyThreeAudioSchema
}).transform(({
  twentyThreeAudio,
  ...rest
}) => ({
  ...rest,
  audioSrc: twentyThreeAudio?.src || rest.audioSrc
}));
const textGroupSchema = z.object({
  type: z.literal("Text"),
  text: z.string().transform(it => decodeHtmlEntities(it))
});
const groupTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("Group"),
  groups: z.array(z.discriminatedUnion("type", [audioDropzoneSchema, imageGroupSchema, textGroupSchema])).optional().default([]).transform(groups => groups.map((it, index) => ({
    ...it,
    id: String(index)
  }))),
  items: z.array(groupTileInput.schema).optional().default([])
}).transform(({
  items,
  ...rest
}) => {
  const content = items.map((it, index) => groupTileInput.postprocessSchemaInput(it, {
    taskId: rest.id,
    index,
    arr: items
  }));
  return {
    ...rest,
    __orderedContent: content,
    content: knuthShuffle(structuredClone(content))
  };
});

export { audioDropzoneSchema, groupTaskSchema, imageGroupSchema, textGroupSchema };
//# sourceMappingURL=_schema.js.map
